export function formatUserName(
  firstName: string | null | undefined,
  lastName: string | null | undefined,
  defaultLabel: string,
  formatFn?: (input: string) => string,
): string {
  const name =
    firstName && lastName ? `${firstName} ${lastName}` : firstName || lastName || defaultLabel

  return formatFn ? formatFn(name) : name
}
